const Properties = {
    "linkedinURL": "https://www.linkedin.com/company/ytechnz",
    "facebookURL" : "https://www.facebook.com/ytechnz",
    "instagramURL" : "https://www.instagram.com/ytechnz/",
    "emailYTech" : "ytech.committee@gmail.com"
};

export default Properties;